import clsx from "clsx";
import styles from "./index.module.scss";

export default function CheckboxNew({
  onChange = () => {},
  checked,
  label,
  test = "",
}) {
  return (
    <label className={styles.Checkbox}>
      <input
        type="checkbox"
        className={styles.Input}
        checked={Boolean(checked)}
        onChange={onChange}
      />
      <span
        className={clsx(styles.Box, checked && styles.BoxChecked)}
        data-test={test}
      >
        {checked && (
          <svg
            width="9"
            height="6"
            viewBox="0 0 9 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.93738 0.219606C8.23027 0.512499 8.23027 0.987373 7.93738 1.28027L3.7387 5.47894C3.44581 5.77183 2.97094 5.77183 2.67804 5.47894L0.219725 3.02062C-0.073168 2.72773 -0.073168 2.25286 0.219725 1.95996C0.512619 1.66707 0.987493 1.66707 1.28039 1.95996L3.20838 3.88795L6.87672 0.219606C7.16961 -0.073287 7.64449 -0.0732871 7.93738 0.219606Z"
              fill="#fff"
            />
          </svg>
        )}
      </span>
      {label && <span>{label}</span>}
    </label>
  );
}
